import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Hammer from 'react-hammerjs'
import { func } from 'prop-types'
import { toggleSidebar } from '../../../store/Actions/UiActions'
import './styles/EdgeSwipe.css'

class EdgeSwipe extends PureComponent {
  handlePan = () => {
    this.props.toggleSidebar(true)
    this.props.registerEvent({
      category: 'EdgeSwipe',
      action: 'DIRECTION_RIGHT (toggle sidebar)',
      label: 'edge-swipe',
    })
  }
  render() {
    return (
      <Hammer onPan={() => this.handlePan()} direction="DIRECTION_RIGHT">
        <div className="edgeswipe-area" />
      </Hammer>
    )
  }
}

EdgeSwipe.propTypes = {
  toggleSidebar: func.isRequired,
  registerEvent: func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  toggleSidebar: value => dispatch(toggleSidebar(value)),
})

export default connect(null, mapDispatchToProps)(EdgeSwipe)



// WEBPACK FOOTER //
// ./src/components/Elements/EdgeSwipe/index.jsx